module.exports = __webpack_public_path__ + "static/media/rocket_lander_3d.55f251ea.webp";